import { render, staticRenderFns } from "./roleManage.vue?vue&type=template&id=3baf1b6b&scoped=true&"
import script from "./roleManage.vue?vue&type=script&lang=js&"
export * from "./roleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf1b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3baf1b6b')) {
      api.createRecord('3baf1b6b', component.options)
    } else {
      api.reload('3baf1b6b', component.options)
    }
    module.hot.accept("./roleManage.vue?vue&type=template&id=3baf1b6b&scoped=true&", function () {
      api.rerender('3baf1b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/comm/roleManage/roleManage.vue"
export default component.exports